import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-external',
  templateUrl: './layout-external.component.html',
  styleUrls: ['./layout-external.component.scss']
})
export class LayoutExternalComponent {
  constructor() {}
}
